<script>
import Datatable from '@/components/Datatable'

export default {
  name: 'LogModal',
  props:[
    "list"
  ],
  components: {
    Datatable,
  },
  data() {
    return {

      columns: [
          { name: 'İstek İp', key: 'ip',  width: 150},
          { name: 'Cihaz', key: 'platform', width: 150 },
          { name: 'Tarayıcı', key: 'browser', className: 'text-end', width: 150  },
          { name: 'Başarılımı', key: 'username', className: 'text-end', width: 150  },
          { name: 'Tarih', key: 'created_at', className: 'text-center', width: 350, orderable: true,  },
        ],
        tableData: {
          data: [],
          pagination: {},
          detail: false,
          excel: false, 
        },
        isLoading: false,
        pageLoading: false,
        params: {
          per_page: 50,
          page: 1 
        },
        sortColumn: null,
        sortOrder: null,
        searchQuery: '',
        pagination:'pagination'
    }
  },
  watch:{
    list(){
      this.rows = []
      this.loadPage(); 
    }
  },

 
  methods: {


    async loadPage() {
      
      this.isLoading = true 

      try {
        const response = await  this.$http.post(`users/${this.list.username}/log`, { params: this.params, sort_column:this.sortColumn, sort_crder:this.sortOrder, search_query: this.searchQuery });

        this.tableData.data = response.data.data;
        this.tableData.pagination = {  current_page:response.data.current_page,  last_page:response.data.last_page, total:response.data.total};
        this.isLoading = false

      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Veri yüklenirken bir hata oluştu:", error);
        this.isLoading = false
      }
      
    },

    pageChange(page){
      if (this.isLoading) return;

      this.params.page = page;
      this.loadPage();
    },

   
    handleSortColumn(columnKey, sortOrder) {
      if (this.isLoading) return;

      this.params.page = 1;
     

      this.sortColumn = columnKey;
      this.sortOrder = sortOrder;
      this.loadPage();
    },

    platform(platform){
       if (platform == 'desktop') {
            return "PC";
        } else if (platform == 'phone') {
            return "Telefon";
        } else if (platform == 'tablet') {
            return "Tablet";
        } else {
            return "Diğer";
        }
    },


    close(){
      this.$parent.$bvModal.hide('modal-log')
    }
  },
};
</script>

<template>
  <b-modal id="modal-log" size="lg" :title="`${list.username} Giriş Bilgileri`"  no-close-on-backdrop hide-footer>
    <div class="row" id="modalScroll">
      <div class="col-12">
        <Datatable 
            :columns="columns" 
            :tableData="tableData" 
            @sort-column="handleSortColumn"
            @page-change="pageChange"
            :loading="isLoading"
            :poading="pageLoading"
            :tableDataLoad="pagination">

            

          <template #active="{ row }">
            <span v-if="row.active"  class="badge rounded-pill bg-success"><i class="fa fa-check"></i> Aktif </span>
            <span v-if="!row.active"  class="badge rounded-pill bg-danger"><i class="fa fa-times"></i> Pasif </span>
          </template> 
          
         
          <template #platform="{ row }">
            {{ platform(row.platform) }}
          </template> 
          
          
          <template #direction="{ row }">
            <span class="badge rounded-pill bg-success" v-if="row.direction == 1">Başarılı</span>
            <span class="badge rounded-pill bg-danger" v-else>Başarısız Deneme</span>
          </template> 

          
          <template #action="{ row }">
            <b-dropdown
                toggle-class="font-size-16 p-0"
                toggle-tag="a"
                variant="white"
                append-to-body
                >
                <template #button-content>
                  <i class="mdi mdi-dots-horizontal"></i>
                  </template>
                  <b-dropdown-item @click="ability(row)">Yetkileri</b-dropdown-item>
                  <b-dropdown-item @click="update(row)">Güncelle</b-dropdown-item>
                  <b-dropdown-item @click="log(row)">Giriş Logları</b-dropdown-item>
              </b-dropdown>
          </template>
        </Datatable>
      </div>
    </div>
</b-modal>
</template>